(function () {
  const HOST_ID = 'ads-agent-host';
  const WAIT_MS = 8000;
  const POLL_MS = 150;

  function getEntrypoint() {
    const host = document.getElementById(HOST_ID);
    if (!host?.shadowRoot) return null;

    const root = host.shadowRoot;
    return (
      root.querySelector('[data-testid="entrypoint"] [role="button"]') ||
      root.querySelector('[role="button"][aria-label*="Shopping Agent"]') ||
      root.querySelector('[data-testid="entrypoint"]')
    );
  }

  function openAdsAgent() {
    const target = getEntrypoint();
    if (!target) return false;
    target.click();
    return true;
  }

  function openAdsAgentWhenReady() {
    if (openAdsAgent()) return;

    const started = Date.now();
    const timer = setInterval(() => {
      if (openAdsAgent() || Date.now() - started > WAIT_MS) {
        clearInterval(timer);
      }
    }, POLL_MS);
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-open-ads-agent]');
    if (!trigger) return;
    event.preventDefault();
    openAdsAgentWhenReady();
  });
})();
